import { instance } from '@/services/iss-nattag-api.service'
import { Location } from '@/types/location'
import { AxiosResponse } from 'axios'

const URL = 'location'

export const getLocations = (): Promise<AxiosResponse<Location[]>> =>
  instance.get(URL)
